export default {
      id: "big-marker-usage",
      viewBox: "0 0 87 133",
      url: __webpack_public_path__ + "sprite.svg#big-marker",
      toString: function () {
        return this.url;
      }
    }